import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M4.25 13C4.66421 13 5 12.6642 5 12.25C5 11.8358 4.66421 11.5 4.25 11.5C3.83579 11.5 3.5 11.8358 3.5 12.25C3.5 12.6642 3.83579 13 4.25 13Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M6.25 11C6.66421 11 7 10.6642 7 10.25C7 9.83579 6.66421 9.5 6.25 9.5C5.83579 9.5 5.5 9.83579 5.5 10.25C5.5 10.6642 5.83579 11 6.25 11Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					opacity: .902,
					d: "M2.75 15.5C3.16421 15.5 3.5 15.1642 3.5 14.75C3.5 14.3358 3.16421 14 2.75 14C2.33579 14 2 14.3358 2 14.75C2 15.1642 2.33579 15.5 2.75 15.5Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					opacity: .902,
					d: "M9.25 13C9.66421 13 10 12.6642 10 12.25C10 11.8358 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.8358 8.5 12.25C8.5 12.6642 8.83579 13 9.25 13Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					opacity: .902,
					d: "M18.25 16C18.6642 16 19 15.6642 19 15.25C19 14.8358 18.6642 14.5 18.25 14.5C17.8358 14.5 17.5 14.8358 17.5 15.25C17.5 15.6642 17.8358 16 18.25 16Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					opacity: .902,
					d: "M14.75 4C15.1642 4 15.5 3.66421 15.5 3.25C15.5 2.83579 15.1642 2.5 14.75 2.5C14.3358 2.5 14 2.83579 14 3.25C14 3.66421 14.3358 4 14.75 4Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					opacity: .902,
					d: "M21.25 6C21.6642 6 22 5.66421 22 5.25C22 4.83579 21.6642 4.5 21.25 4.5C20.8358 4.5 20.5 4.83579 20.5 5.25C20.5 5.66421 20.8358 6 21.25 6Z",
					fill: "#5946E5",
					stroke: "#5946E5",
					strokeWidth: .5
				})
			]
		})
	})
});
export default SvgDot;
